module.exports = __webpack_public_path__ + "media/location/topPhotographers-withBg-fb1c48f7.png";